import * as React from "react";
import { observer } from "mobx-react";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import { CategoryType, CategoryItem, VocabularyCategoryItem } from "models";
import { CategoryItemCardInputBase } from "components/categoryMenu/categoryItemCards/CategoryItemCardInputBase";

import { StringUtils } from "core/utils/StringUtils";
import { strings } from "core/localizedStrings";
import { Grid } from "@material-ui/core";

var Row = require("react-flexbox-grid").Row;

require("../../../styles/commonStyles.css");

@observer
export class VocabularyCardInput extends CategoryItemCardInputBase {
    // Render UI
    // ------------------------------------------
    constructor(props: any, state: any) {
        super(props, state);
        let vocabularyCategoryItem = this.props.categoryItem as VocabularyCategoryItem;
        if (this.props.categoryItem !== undefined && vocabularyCategoryItem.text !== undefined) {
            this.vocabTextFieldValue = vocabularyCategoryItem.text;

            // if (this.props.categoryItem.image !== undefined) {
            //     this.getImageURL();
            // }
        }
    }

    render() {
        return (
            <div style={{ padding: 20, minHeight: 100 }}>
                {this.props.categoryItem.type === CategoryType.Vocabulary && (
                    <Row center="xs" style={{ paddingBottom: 20 }}>
                        <img src={this.props.categoryItem.thumbnailDownloadURL} style={{ height: 300 }} />
                    </Row>
                )}

                <Grid container alignItems="flex-end">
                    <Grid item>
                        <TextField
                            id="text"
                            inputRef={(ref) => {
                                this.textInputRef = ref;
                            }}
                            label={strings.enterText}
                            inputProps={{ style: { fontSize: 24 } }}
                            fullWidth={true}
                            value={this.vocabTextFieldValue}
                            onChange={this.onTextFieldChange}
                            onKeyDown={this.onKeyDown}
                        />
                    </Grid>
                    <Grid item>
                        <Button variant="contained" onClick={this.onEditComplete} style={{ marginLeft: 10 }}>
                            {strings.ok}
                        </Button>
                    </Grid>
                </Grid>
            </div>
        );
    }

    protected setCategoryItemPropertiesFromTextFields(categoryItem: CategoryItem) {
        if (categoryItem instanceof VocabularyCategoryItem) {
            if (!StringUtils.isEmptyOrUndefined(this.vocabTextFieldValue)) {
                categoryItem.text = this.vocabTextFieldValue.trim();
            }
        }
    }
}
